export default __webpack_public_path__ + "static/media/o-universe.126407a2.webp";